import React from "react";

const DeleteCandidateModal = (props) => {
  const translateText = (LabelId) => {
    var Filter = "label_id";
    var Keyword = LabelId;
    var Label = props.LangData.filter((Obj) => {
      return Obj[Filter] === Keyword;
    });
    return Label[0].label_value;
  };

  return (
    <div className="modal-overlay">
      <div className="outline" onClick={() => props.Close()}></div>
      <section className="modal-body">
        <section className="modal-head">
          <p>{props.Title}</p>
          <i className="feather-x" onClick={() => props.Close()}></i>
        </section>
        <section className="modal-info">
          {translateText("delete_modal_text")}
        </section>
        <section className="modal-actions">
          <span className="secondary-action" onClick={() => props.Close()}>
            {translateText("cancel")}
          </span>
          <span className="main-action">{translateText("delete")}</span>
        </section>
      </section>
    </div>
  );
};

export default DeleteCandidateModal;
